var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 137,
    viewBox: "0 0 117 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.2683 34.6111C79.041 51.9161 79.8313 68.5 79.8313 68.5C79.8313 68.5 79.0409 85.0839 93.2682 102.389C103.544 115.368 113.028 117.531 116.19 120.415C119.352 123.299 112.238 127.625 112.238 127.625C100.759 134.339 87.7818 136.642 74.2985 136.999C59.3864 137.061 43.9494 134.771 29.2454 124.741C10.0852 111.671 -0.0720178 90.0292 0.000445333 68.5C-0.0720178 46.9708 10.0852 25.3286 29.2455 12.2589C43.9494 2.22888 59.3865 -0.0613723 74.2986 0.00123711C87.7819 0.358143 100.759 2.66075 112.238 9.37477C112.238 9.37477 119.352 13.701 116.19 16.5852C113.028 19.4693 103.544 21.6324 93.2683 34.6111Z",
    fill: "#FFA500"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 48.5,
    r: 4.5,
    fill: "#FFC100"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 114,
    r: 5,
    fill: "#FFC100"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 101,
    r: 5,
    fill: "#FFC100"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 21.5,
    r: 4.5,
    fill: "#FFC100"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 31.5,
    r: 5.5,
    fill: "#FFC100"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 79.5,
    r: 5.5,
    fill: "#FFC100"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 67,
    r: 7,
    fill: "#FFC100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.5182c3793977886748db1405a0c00e6b.svg";
export { ForwardRef as ReactComponent };